import type { ColumnDef } from "@tanstack/react-table"
import { useState } from "react"

import { companyProductListColumns } from "../productColumns"

import type { Product } from "@/graphql/codegen/graphql"
import { SortingOrder } from "@/graphql/codegen/graphql"

interface UseProductTableProps {
  sortBy?: string
  sortOrder?: SortingOrder
}

interface UseProductTableReturn {
  columns: ColumnDef<Product>[]
  sorting: { id: string; desc: boolean }[]
  setSorting: (sorting: { id: string; desc: boolean }[]) => void
}

export const useProductTable = ({ sortBy, sortOrder }: UseProductTableProps): UseProductTableReturn => {
  const [sorting, setSorting] = useState([
    {
      id: sortBy || "publicId",
      desc: sortOrder === SortingOrder.Desc,
    },
  ])

  return {
    columns: companyProductListColumns,
    sorting,
    setSorting,
  }
}
